import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import { DependentDatePickerData } from 'src/app/interfaces/form-and-field.interface';
import { MaybeNull } from 'src/app/utils';

function padNumber(value: number): string {
  return isNumber(value) ? `0${value}`.slice(-2) : '';
}

function isNumber(value: unknown): boolean {
  return !isNaN(toInteger(value as string));
}

function toInteger(value: string): number {
  return parseInt(`${value}`, 10);
}

@Injectable()
export class CustomDateFormatter extends NgbDateParserFormatter {
  // TODO: add tests
  public parse(value: string | DependentDatePickerData): MaybeNull<NgbDateStruct> {
    if (typeof value === 'object') {
      value = value.origin;
    }

    if (value) {
      const dateParts: string[] = value.toString().trim().split(/[-./]/g);

      const [y, m, d] = dateParts;

      if (!y || !m || !d) {
        return null;
      }

      if (isNumber(y) && isNumber(m) && isNumber(d)) {
        return {
          year: toInteger(y),
          month: toInteger(m),
          day: toInteger(d),
        };
      }
    }

    return null;
  }

  public format(date: NgbDateStruct): string {
    let stringDate = '';
    if (date) {
      stringDate += isNumber(date.month) ? padNumber(date.month) + '/' : '';
      stringDate += isNumber(date.day) ? padNumber(date.day) + '/' : '';
      stringDate += date.year;
    }
    return stringDate;
  }
}
